module.exports = __webpack_public_path__ + "img/lineup10@2x.5bff4203.png";